module.exports = __webpack_public_path__ + "static/img/1.2e8a2cfa.gif";